export default __webpack_public_path__ + "static/media/yesRemote.2b1b66ad.svg";